export default "__VITE_ASSET__DAclBHJs__"